import type { WritableSignal } from '@angular/core';
import type { Subject } from 'rxjs';
import type { PageInfo } from '../../shared/interfaces/pagination.interface';

export interface PalantirBasePaginationService {
  isLoading: WritableSignal<boolean>;
  isSearching?: WritableSignal<boolean>;
  pageInfo: WritableSignal<PageInfo | undefined>;
  pageRangeBuilder(start: number, end: number, totalCount: number): string;
  search$: Subject<any>;
  skip: WritableSignal<number>;
  take: WritableSignal<number>;
  totalCount: WritableSignal<number>;
}

export enum PalantirPaginationLayoutEnum {
  default = 'default',
  short = 'short',
}

export type PalantirPaginationLayout = keyof typeof PalantirPaginationLayoutEnum;
